export enum KeyboardEventKeyEnum {
	Backspace = 'Backspace',
	Tab = 'Tab',
	Enter = 'Enter',
	Delete = 'Delete',
	F2 = 'F2',
	Left = 'ArrowLeft',
	Right = 'ArrowRight',
}
